import React from "react";
import Modal from "react-modal";

Modal.setAppElement('#root')


export default props => (
  <Modal
    id={props.idView}
    isOpen={props.modalIsOpen}
    onAfterOpen={props.afterOpenModal}
    onRequestClose={props.closeModal}
    style={props.style}
    contentLabel="Example Modal"
  >
    <props.Content />
    <div className="close" onClick={props.closeModal}></div>
  </Modal>
);  
